"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAdminOrAbove = exports.CLIRA_ROLES = exports.BYGGFAKTA_ROLES = exports.TENDIUM_ROLES = exports.ALL = exports.FEATURE_ROLES = exports.PAYMENT_ROLES = exports.BASIC_AND_ABOVE = exports.ADMIN_AND_ABOVE = exports.FeatureRole = exports.PaymentRole = exports.Role = void 0;
// Add all new Payment and FeatureRoles here
const enum_util_1 = require("./enum-util");
var Role;
(function (Role) {
    Role["NOT_ACTIVATED"] = "NOT_ACTIVATED";
    Role["START"] = "START";
    Role["TEAM"] = "TEAM";
    Role["BUSINESS"] = "BUSINESS";
    Role["PREMIUM_USER"] = "PREMIUM_USER";
    Role["ADMIN"] = "ADMIN";
    Role["BASIC_USER"] = "BASIC_USER";
    Role["ROOT"] = "ROOT";
    Role["ENTERPRISE"] = "ENTERPRISE";
    Role["PLUS"] = "PLUS";
    Role["TENDIUM"] = "TENDIUM";
    Role["STUDENT"] = "STUDENT";
    Role["SERVICE_USER"] = "SERVICE_USER";
    Role["BF_BASIC"] = "BF_BASIC";
    Role["BF_PLUS"] = "BF_PLUS";
    Role["BF_PREMIUM"] = "BF_PREMIUM";
    Role["BF_ENTERPRISE"] = "BF_ENTERPRISE";
    Role["BF_ADMIN"] = "BF_ADMIN";
    Role["BETA_USER"] = "BETA_USER";
    Role["CLR_ADMIN"] = "CLR_ADMIN";
    Role["CLR_PROCURER"] = "CLR_PROCURER";
    Role["LIGHT"] = "LIGHT";
    Role["MERCURY_BETA_USER"] = "MERCURY_BETA_USER";
    Role["Auth_2FA"] = "Auth_2FA";
    Role["SupportWidget_Enable"] = "SupportWidget_Enable";
    Role["MatchingProfile_AlwaysNonTedBox"] = "MatchingProfile_AlwaysNonTedBox";
    Role["Interactions_ShareWithGuestUsers"] = "Interactions_ShareWithGuestUsers";
    Role["MatchingProfile_BuyerFilter"] = "MatchingProfile_BuyerFilter";
    Role["InviteTeammates"] = "InviteTeammates";
    Role["Users_Webhooks"] = "Users_Webhooks";
    Role["Interactions_DocumentLibrary"] = "Interactions_DocumentLibrary";
    Role["PDF_Download"] = "PDF_Download";
    Role["NonTedBoxes"] = "NonTedBoxes";
    Role["Users_Competitors"] = "Users_Competitors";
    Role["Interactions_ProcurementLevelComments"] = "Interactions_ProcurementLevelComments";
    Role["Users_IntegrationToken"] = "Users_IntegrationToken";
    Role["MatchingProfile_BroadOrNarrowSearchInDocuments"] = "MatchingProfile_BroadOrNarrowSearchInDocuments";
    Role["Auth_SSO"] = "Auth_SSO";
    Role["BiddingWorkflow_Tasks"] = "BiddingWorkflow_Tasks";
    Role["BiddingWorkflow_Preview"] = "BiddingWorkflow_Preview";
    Role["MatchingProfile_HighlightOnly"] = "MatchingProfile_HighlightOnly";
    Role["MatchingProfile_HistoricalTenderFilter"] = "MatchingProfile_HistoricalTenderFilter";
    Role["KeywordSearch"] = "KeywordSearch";
    Role["KnowledgeBank"] = "KnowledgeBank";
    Role["EditableDetailspage"] = "EditableDetailspage";
    Role["CustomBidFields"] = "CustomBidFields";
    Role["ShowOnlyAwarded"] = "ShowOnlyAwarded";
    Role["MicrosoftTeams"] = "MicrosoftTeams";
    Role["BidStages"] = "BidStages";
    Role["AnalyticsHomepage"] = "AnalyticsHomepage";
    Role["AnalyticsOrganisationProfiles"] = "AnalyticsOrganisationProfiles";
    Role["DefaultSearchProfile"] = "DefaultSearchProfile";
    Role["ByggfaktaSmartLink"] = "ByggfaktaSmartLink";
    Role["AnalyticsExpiringContracts"] = "AnalyticsExpiringContracts";
    Role["ProductVoice"] = "ProductVoice";
    Role["Checklist"] = "Checklist";
    Role["BiddingTool_BiddingGPT_CSV"] = "BiddingTool_BiddingGPT_CSV";
    Role["BiddingTool_BiddingGPT"] = "BiddingTool_BiddingGPT";
    Role["Interactions_ProcurementUsageInProm"] = "Interactions_ProcurementUsageInProm";
    Role["ManualBids"] = "ManualBids";
    Role["SearchLimit50"] = "SearchLimit50";
    Role["Workspace_Export"] = "Workspace_Export";
    Role["ByggfaktaPrivate"] = "ByggfaktaPrivate";
    Role["MonitoringProfiles"] = "MonitoringProfiles";
    Role["Bidspaces"] = "Bidspaces";
    Role["MatchingProfile_AdvancedFilters"] = "MatchingProfile_AdvancedFilters";
    Role["AnalyticsExpiringContractsLight"] = "AnalyticsExpiringContractsLight";
    Role["AnalyticsMarketDashboard"] = "AnalyticsMarketDashboard";
    Role["Release_TaskHighlightPreview"] = "Release_TaskHighlightPreview";
    Role["BiddingTool_BiddingGPT_ContentLibrary"] = "BiddingTool_BiddingGPT_ContentLibrary";
    Role["MatchingProfile_AndKeywords"] = "MatchingProfile_AndKeywords";
    Role["UserTeams"] = "UserTeams";
    Role["AllTenders"] = "AllTenders";
    Role["Workspace_All"] = "Workspace_All";
    Role["Workspace_Dashboard"] = "Workspace_Dashboard";
    Role["Reminders"] = "Reminders";
    Role["GPT_Summary"] = "GPT_Summary";
    Role["BidAttachments"] = "BidAttachments";
    Role["Analytics_Billing_During_Contract"] = "Analytics_Billing_During_Contract";
    Role["MatchingProfile_Relevance"] = "MatchingProfile_Relevance";
    Role["Analytics_Previous_Procurements"] = "Analytics_Previous_Procurements";
    // Notifications for tender updates
    Role["TenderUpdatesDocuments"] = "TenderUpdatesDocuments";
    Role["TenderUpdatesDeadline"] = "TenderUpdatesDeadline";
    Role["TenderUpdatesAdditions"] = "TenderUpdatesAdditions";
    Role["TenderUpdatesAwards"] = "TenderUpdatesAwards";
    Role["TenderUpdatesCanceledTender"] = "TenderUpdatesCanceledTender";
    Role["TenderUpdatesQuestionDeadline"] = "TenderUpdatesQuestionDeadline";
    Role["TenderUpdatesValidityPeriod"] = "TenderUpdatesValidityPeriod";
    Role["TenderUpdatesQA"] = "TenderUpdatesQA";
})(Role = exports.Role || (exports.Role = {}));
// noinspection JSUnusedGlobalSymbols
var PaymentRole;
(function (PaymentRole) {
    PaymentRole["ROOT"] = "ROOT";
    PaymentRole["ADMIN"] = "ADMIN";
    PaymentRole["ENTERPRISE"] = "ENTERPRISE";
    PaymentRole["PLUS"] = "PLUS";
    PaymentRole["PREMIUM_USER"] = "PREMIUM_USER";
    PaymentRole["BASIC_USER"] = "BASIC_USER";
    PaymentRole["TENDIUM"] = "TENDIUM";
    PaymentRole["STUDENT"] = "STUDENT";
    PaymentRole["SERVICE_USER"] = "SERVICE_USER";
    PaymentRole["START"] = "START";
    PaymentRole["TEAM"] = "TEAM";
    PaymentRole["BUSINESS"] = "BUSINESS";
    PaymentRole["NOT_ACTIVATED"] = "NOT_ACTIVATED";
    PaymentRole["BF_BASIC"] = "BF_BASIC";
    PaymentRole["BF_PLUS"] = "BF_PLUS";
    PaymentRole["BF_PREMIUM"] = "BF_PREMIUM";
    PaymentRole["BF_ENTERPRISE"] = "BF_ENTERPRISE";
    PaymentRole["BF_ADMIN"] = "BF_ADMIN";
    PaymentRole["CLR_ADMIN"] = "CLR_ADMIN";
    PaymentRole["CLR_PROCURER"] = "CLR_PROCURER";
    PaymentRole["LIGHT"] = "LIGHT";
})(PaymentRole = exports.PaymentRole || (exports.PaymentRole = {}));
// noinspection JSUnusedGlobalSymbols
var FeatureRole;
(function (FeatureRole) {
    FeatureRole["BETA_USER"] = "BETA_USER";
    FeatureRole["MERCURY_BETA_USER"] = "MERCURY_BETA_USER";
    FeatureRole["Auth_2FA"] = "Auth_2FA";
    FeatureRole["SupportWidget_Enable"] = "SupportWidget_Enable";
    FeatureRole["MatchingProfile_AlwaysNonTedBox"] = "MatchingProfile_AlwaysNonTedBox";
    FeatureRole["Interactions_ShareWithGuestUsers"] = "Interactions_ShareWithGuestUsers";
    FeatureRole["MatchingProfile_BuyerFilter"] = "MatchingProfile_BuyerFilter";
    FeatureRole["InviteTeammates"] = "InviteTeammates";
    FeatureRole["Users_Webhooks"] = "Users_Webhooks";
    FeatureRole["Interactions_DocumentLibrary"] = "Interactions_DocumentLibrary";
    FeatureRole["PDF_Download"] = "PDF_Download";
    FeatureRole["NonTedBoxes"] = "NonTedBoxes";
    FeatureRole["Users_Competitors"] = "Users_Competitors";
    FeatureRole["Interactions_ProcurementLevelComments"] = "Interactions_ProcurementLevelComments";
    FeatureRole["Users_IntegrationToken"] = "Users_IntegrationToken";
    FeatureRole["MatchingProfile_BroadOrNarrowSearchInDocuments"] = "MatchingProfile_BroadOrNarrowSearchInDocuments";
    FeatureRole["Auth_SSO"] = "Auth_SSO";
    FeatureRole["BiddingWorkflow_Tasks"] = "BiddingWorkflow_Tasks";
    FeatureRole["BiddingWorkflow_Preview"] = "BiddingWorkflow_Preview";
    FeatureRole["MatchingProfile_HighlightOnly"] = "MatchingProfile_HighlightOnly";
    FeatureRole["MatchingProfile_HistoricalTenderFilter"] = "MatchingProfile_HistoricalTenderFilter";
    FeatureRole["KeywordSearch"] = "KeywordSearch";
    FeatureRole["KnowledgeBank"] = "KnowledgeBank";
    FeatureRole["EditableDetailspage"] = "EditableDetailspage";
    FeatureRole["CustomBidFields"] = "CustomBidFields";
    FeatureRole["ShowOnlyAwarded"] = "ShowOnlyAwarded";
    FeatureRole["MicrosoftTeams"] = "MicrosoftTeams";
    FeatureRole["BidStages"] = "BidStages";
    FeatureRole["AnalyticsHomepage"] = "AnalyticsHomepage";
    FeatureRole["AnalyticsOrganisationProfiles"] = "AnalyticsOrganisationProfiles";
    FeatureRole["DefaultSearchProfile"] = "DefaultSearchProfile";
    FeatureRole["ByggfaktaSmartLink"] = "ByggfaktaSmartLink";
    FeatureRole["AnalyticsExpiringContracts"] = "AnalyticsExpiringContracts";
    FeatureRole["ProductVoice"] = "ProductVoice";
    FeatureRole["Checklist"] = "Checklist";
    FeatureRole["BiddingTool_BiddingGPT_CSV"] = "BiddingTool_BiddingGPT_CSV";
    FeatureRole["BiddingTool_BiddingGPT"] = "BiddingTool_BiddingGPT";
    FeatureRole["Interactions_ProcurementUsageInProm"] = "Interactions_ProcurementUsageInProm";
    FeatureRole["ManualBids"] = "ManualBids";
    FeatureRole["SearchLimit50"] = "SearchLimit50";
    FeatureRole["Workspace_Export"] = "Workspace_Export";
    FeatureRole["ByggfaktaPrivate"] = "ByggfaktaPrivate";
    FeatureRole["MonitoringProfiles"] = "MonitoringProfiles";
    FeatureRole["Bidspaces"] = "Bidspaces";
    FeatureRole["MatchingProfile_AdvancedFilters"] = "MatchingProfile_AdvancedFilters";
    FeatureRole["AnalyticsExpiringContractsLight"] = "AnalyticsExpiringContractsLight";
    FeatureRole["AnalyticsMarketDashboard"] = "AnalyticsMarketDashboard";
    FeatureRole["Release_TaskHighlightPreview"] = "Release_TaskHighlightPreview";
    FeatureRole["BiddingTool_BiddingGPT_ContentLibrary"] = "BiddingTool_BiddingGPT_ContentLibrary";
    FeatureRole["MatchingProfile_AndKeywords"] = "MatchingProfile_AndKeywords";
    FeatureRole["UserTeams"] = "UserTeams";
    FeatureRole["AllTenders"] = "AllTenders";
    FeatureRole["Workspace_All"] = "Workspace_All";
    FeatureRole["Workspace_Dashboard"] = "Workspace_Dashboard";
    FeatureRole["Reminders"] = "Reminders";
    FeatureRole["GPT_Summary"] = "GPT_Summary";
    FeatureRole["BidAttachments"] = "BidAttachments";
    FeatureRole["Analytics_Billing_During_Contract"] = "Analytics_Billing_During_Contract";
    FeatureRole["MatchingProfile_Relevance"] = "MatchingProfile_Relevance";
    FeatureRole["Analytics_Previous_Procurements"] = "Analytics_Previous_Procurements";
    // Notifications for tender updates
    FeatureRole["TenderUpdatesDocuments"] = "TenderUpdatesDocuments";
    FeatureRole["TenderUpdatesDeadline"] = "TenderUpdatesDeadline";
    FeatureRole["TenderUpdatesAdditions"] = "TenderUpdatesAdditions";
    FeatureRole["TenderUpdatesAwards"] = "TenderUpdatesAwards";
    FeatureRole["TenderUpdatesCanceledTender"] = "TenderUpdatesCanceledTender";
    FeatureRole["TenderUpdatesQuestionDeadline"] = "TenderUpdatesQuestionDeadline";
    FeatureRole["TenderUpdatesValidityPeriod"] = "TenderUpdatesValidityPeriod";
    FeatureRole["TenderUpdatesQA"] = "TenderUpdatesQA";
})(FeatureRole = exports.FeatureRole || (exports.FeatureRole = {}));
exports.ADMIN_AND_ABOVE = [Role.ADMIN, Role.BF_ADMIN, Role.CLR_ADMIN, Role.ROOT];
// Deprecated - should not be exported anymore
const PREMIUM_AND_ABOVE = [Role.PREMIUM_USER, Role.BF_PREMIUM, Role.ENTERPRISE, Role.BF_ENTERPRISE, ...exports.ADMIN_AND_ABOVE];
exports.BASIC_AND_ABOVE = [
    Role.BASIC_USER,
    Role.BF_BASIC,
    Role.PLUS,
    Role.BF_PLUS,
    Role.TENDIUM,
    Role.STUDENT,
    Role.START,
    Role.TEAM,
    Role.BUSINESS,
    Role.SERVICE_USER,
    Role.CLR_PROCURER,
    Role.LIGHT,
    ...PREMIUM_AND_ABOVE,
];
// noinspection JSUnusedGlobalSymbols
exports.PAYMENT_ROLES = (0, enum_util_1.getValuesFromEnum)(PaymentRole);
// noinspection JSUnusedGlobalSymbols
exports.FEATURE_ROLES = (0, enum_util_1.getValuesFromEnum)(FeatureRole);
exports.ALL = (0, enum_util_1.getValuesFromEnum)(Role);
exports.TENDIUM_ROLES = [
    Role.START,
    Role.TEAM,
    Role.BUSINESS,
    Role.BASIC_USER,
    Role.PLUS,
    Role.PREMIUM_USER,
    Role.ENTERPRISE,
    Role.ADMIN,
    Role.TENDIUM,
    Role.STUDENT,
    Role.SERVICE_USER,
    Role.NOT_ACTIVATED,
    Role.LIGHT,
    Role.ROOT,
];
exports.BYGGFAKTA_ROLES = [Role.BF_BASIC, Role.BF_PLUS, Role.BF_PREMIUM, Role.BF_ENTERPRISE, Role.BF_ADMIN];
exports.CLIRA_ROLES = [Role.CLR_ADMIN, Role.CLR_PROCURER];
/**
 * Given a priceplan, return if its an adminOrAbove PricePlan
 * @param pricePlan input price plan
 * @returns boolean true if its admin or above
 */
function isAdminOrAbove(pricePlan) {
    return exports.ADMIN_AND_ABOVE.some((adminRole) => {
        return adminRole.toString() === pricePlan.toString();
    });
}
exports.isAdminOrAbove = isAdminOrAbove;
